var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryStatusAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D0E0E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5207 8.65967V6.5H18.329V8.65967H11.671V6.5H8.47825V8.65967H6V23.5H24V8.65967H21.5207V8.65967ZM7.769 20.9833V11.1763H22.231V20.9833H7.769Z",
    fill: "#45748C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13.5,
    width: 3,
    height: 2,
    fill: "#45748C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7758 12.5H18.2255V13.7251H17V15.2749H18.2255V16.5H19.7758V15.2749H21V13.7251H19.7758V12.5Z",
    fill: "#45748C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryStatusAlert);
export default __webpack_public_path__ + "static/media/batteryStatusAlert.482c3418d167248bfca2cbe20a6b3479.svg";
export { ForwardRef as ReactComponent };